export interface SectionCompareHighlightSegment {
  text: string;
  /** True when this span matches one of the absent (not-on-your-page) terms. */
  highlighted: boolean;
}

/**
 * Split a competitor section body into plain/highlighted spans, marking the
 * phrases that are absent from your focal page. Longest terms match first so
 * multi-word phrases win over their sub-tokens.
 */
export function splitSectionTextByAbsentTerms(
  text: string,
  absentTerms: string[]
): SectionCompareHighlightSegment[] {
  const source = (text || '').trim();
  if (!source) return [{ text: '', highlighted: false }];

  const terms = (absentTerms || [])
    .map((t) => (t || '').trim().toLowerCase())
    .filter((t) => t.length >= 2);
  if (!terms.length) return [{ text: source, highlighted: false }];

  const lower = source.toLowerCase();
  const flags = new Array<boolean>(source.length).fill(false);

  const sorted = [...terms].sort((a, b) => b.length - a.length);
  for (const term of sorted) {
    let idx = 0;
    while (idx < lower.length) {
      const pos = lower.indexOf(term, idx);
      if (pos === -1) break;
      for (let i = pos; i < pos + term.length; i++) flags[i] = true;
      idx = pos + term.length;
    }
  }

  const segments: SectionCompareHighlightSegment[] = [];
  let i = 0;
  while (i < source.length) {
    const flag = flags[i];
    let j = i + 1;
    while (j < source.length && flags[j] === flag) j++;
    segments.push({ text: source.slice(i, j), highlighted: flag });
    i = j;
  }
  return segments.filter((s) => s.text.length > 0);
}
